import React from 'react';
import Config, { DeploymentType, IConfig, SourceApp } from '../../../Config';
import WebUtils from '../../../services/WebUtils';

export interface IProps {
    image: string;
    title: string;
    chapterTitle: string;
    chapterLink: string;
    blurb: string;
    bookShortName: string;
    elementShortName: string;
    recommendationBasedOnTitle: string;
    recommendationBasedOnCover: string;
    authors: string;
    publicationDate: string;
    deploymentType: DeploymentType;
    sourceApp: SourceApp;
}
export interface IState {
    blurb: string;
}

export class RecommendedProduct extends React.Component <IProps, IState> {
    private webUtils: WebUtils;
    private config: IConfig;
     
    constructor(props: IProps) {
        super(props);

        this.config = Config.getConfig(this.props.sourceApp, this.props.deploymentType);
        this.webUtils = new WebUtils(this.config);
        // this.fetchBlurb();
    }

    private fetchBlurb() {
        let url = new URL(this.webUtils.getAbsoluteBackendUrl("manningOnline/getElementSummary").replace("3001", "8080"));

        url.searchParams.append('bookShortName', this.props.bookShortName);
        url.searchParams.append('elementShortName', this.props.elementShortName);

        fetch(url.toString())
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
        })
        .then(data => {
            this.setState({blurb: data.topicSummary});
        })
        .catch(error => {
            console.error('There was a problem with the fetch operation: ', error);
            this.setState({blurb: ''});
        });

    }

    public render(){
        let chapterTitle = this.props.chapterTitle;
        // If it starts with "Chapter 2. Testing gdfg", shorten to "ch.2 — Testing gdfg"
        const chapterPattern = /^Chapter (\d+)\. /;
        chapterTitle = chapterTitle.replace(chapterPattern, (match, number) => `ch.${number} — `);
        
        // If it starts with a number, prepend "ch." and add an em-dash, like "ch. 2 — Title"
        const numberStartPattern = /^(\d+) /;
        if (numberStartPattern.test(chapterTitle)) {
            chapterTitle = chapterTitle.replace(numberStartPattern, (match, number) => `ch. ${number} — `);
        }
        let coverUrl = `https://lx-common-resources.s3.us-west-2.amazonaws.com/book-spine-graphics/${this.props.bookShortName}.jpg`;
        return <div className="recommended-item-container">
                    <a href={this.props.chapterLink} className="recommended-item-link" target="_blank" rel="noopener noreferrer">
                        <div className="recommended-item-and-parent">
                            <div className="recommended-item-content">
                            <img className="recommended-item-image" src={coverUrl} onError={(e)=>{if((e.target as HTMLImageElement).src !== "https://lx-common-resources.s3.us-west-2.amazonaws.com/book-spine-graphics/face-temp.jpg"){(e.target as HTMLImageElement).src="https://lx-common-resources.s3.us-west-2.amazonaws.com/book-spine-graphics/face-temp.jpg"}}} />
                            <div className="recommended-item-text-container">
                                    <div className="recommended-item-title-container">
                                        <div className="recommended-item-title">{chapterTitle}</div>
                                    </div>
                                    <div className="recommended-item-title-container">
                                        <div className="recommended-item-chapter-title"><span className='recommended-item-chapter-title-from'>from </span>{this.props.title}</div>
                                    </div>
                                    <div className="recommended-item-blurb-container">
                                        <div className="recommended-item-blurb">{this?.state?.blurb ? this?.state?.blurb : ""}</div>
                                    </div>
                                    {/* <div className="recommended-item-authors-and-date">{this.props.authors} | {this.props.publicationDate}</div> */}
                                </div>
                            </div>
                            <div className='recommended-item-recommendation-based-on'>
                                {/* <img className="recommended-item-recommendation-based-on-cover" src={this.props.recommendationBasedOnCover} /> */}
                                <div className='recommended-item-recommendation-based-on-text-container'>
                                    <div className="recommended-item-recommendation-based-on-text">suggested because you read</div>
                                    <div className="recommended-item-recommendation-based-on-title">{this.props.recommendationBasedOnTitle}</div>
                                </div>
                            </div>
                        </div>    
                    </a>
               </div>
    }
}